export default "__VITE_ASSET__Dptl0BH___"